import { getRequest, postRequest, API } from 'utils/request';

/**
 *Transforms the API response to the structure usable to Multi-Tree filter for processing.
 * @param res : response from channel agent map (only the data part).
 */
const transformMapping = (res: any) => {
  const groupsArr = Object.keys(res);
  const groupNames = groupsArr.map((groupName: string) => {
    const children = res[groupName].map((agent: any) => {
      return {
        key: agent?.agentId || '',
        value: agent?.agentId || '',
        title: agent?.agentName || '',
      };
    });
    return {
      key: groupName,
      value: groupName,
      title: groupName,
      children,
    };
  });

  return { groupNames };
};

const fetchGraphData = async (requestObj: any) => {
  const res: any = await postRequest(API.insights, requestObj);
  return res?.data?.data || {};
};

const getChannelAgentMapping = async () => {
  const res: any = await getRequest(API.channelAgentMapping);
  if (res?.data?.data) {
    return transformMapping(res.data.data);
  }
  return res?.data?.data || {};
};

export { fetchGraphData, getChannelAgentMapping };
